import { Slot } from '@radix-ui/react-slot'

import { cn } from '../../lib/util'
import { TypographyProps } from './typography.types'

import { typographyVariants } from './typography.css'

const Typography = ({ asChild, className, weight, size = 'body1', children, ...props }: TypographyProps) => {
  const Component = asChild ? Slot : 'p'
  return (
    <Component className={cn(typographyVariants({ size, weight }), className)} {...props}>
      {children}
    </Component>
  )
}

export default Typography
